import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Modal from '@tds/community-modal';

const RegistrationModel = ({ show, labels }) => {
  const [showModal, setShowModal] = useState(show);
  const focusElementOnClose = useRef(null);
  const { emailConfirmation, confirmationMessage, close } = labels;
  const history = useHistory();
  const closeModal = () => {
    setShowModal(false);
  };
  const proceed = () => {
    setShowModal(false);
    history.push('/login');
  };

  return (
    <div>
      <Modal
        heading={emailConfirmation}
        bodyText={confirmationMessage}
        confirmCTAText={close}
        focusElementAfterClose={focusElementOnClose}
        onConfirm={proceed}
        onClose={closeModal}
        isOpen={showModal}
      />
    </div>
  );
};

RegistrationModel.defaultProps = {
  show: false
};

RegistrationModel.propTypes = {
  show: PropTypes.bool,
  labels: PropTypes.shape({
    emailConfirmation: PropTypes.string,
    confirmationMessage: PropTypes.string,
    close: PropTypes.string
  }).isRequired
};

export default RegistrationModel;
